<template>

  <svg
    t="1639104862436"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4267"
    width="64"
    height="64"
  ><path d="M517.19104004 526.66674805L133.7956543 334.76306153 514.71911622 144.3425293l380.5114746 190.25573731-378.03955078 192.06848144zM262.6652832 334.84545898l254.36096192 127.30407716 250.07629394-127.05688478-252.38342285-126.23291014L262.6652832 334.84545898z" p-id="4268" /><path d="M517.19104004 705.38684083L133.7956543 513.4831543l126.80969238-63.36364747 66.57714843 31.14624024-64.51721191 32.21740723 254.36096192 127.30407715 250.07629394-127.05688478-63.61083984-31.80541991 62.53967287-33.20617677 129.19921873 64.59960938z" p-id="4269" /><path d="M517.19104004 879.98706055L133.7956543 688.08337403l126.80969238-63.36364747 66.57714843 31.2286377-64.51721191 32.21740722 254.36096192 127.22167969L767.10253906 688.33056641l-63.61083984-31.80541992 62.53967287-33.20617677 129.19921873 64.59960939z" p-id="4270" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconLayer',
} as DefineComponent
</script>